import React from 'react';
import ReactDOM from 'react-dom/client';
import { hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import './i18n';
import { maybeInitAnalytics } from './utils/analytics';

// RGPD: re-init analytics on boot ONLY if user previously consented.
// (CookieConsentBanner calls initAnalytics() directly when consent is given.)
maybeInitAnalytics();

const rootElement = document.getElementById('root');

const Root = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// react-snap pre-renders pages at build time and writes the resulting
// HTML to disk. When a real visitor loads that HTML, React must HYDRATE
// the existing DOM (not re-create it). We detect this by checking if
// the root element already has children.
//
// Without this, react-snap output is wiped on first client render,
// causing a flash of empty content and breaking SEO benefits.
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, Root);
} else {
  ReactDOM.createRoot(rootElement).render(Root);
}
